module.exports = __webpack_public_path__ + "media/images/common/sns/facebook-37f36878c78ff7c123e9fdbb1a0230cd.svg";